<kt-base-modal
  [title]="(task?.task_group_name || task?.task_group?.task_group_name || task?.timesheet_task_group_fk_task_group_name || task?.timesheet_task_group?.timesheet_task_group_fk_task_group_name) + ' Task'">
  <div modal-body>
    <kt-loader [showLoader]="loading()">
      <div class="kt-widget2 fix-body-height">
        <!-- Complete -->
        <div *ngIf="task?.task_group?.task_group_name || task?.timesheet_task_group_fk_task_group_name"
          class="p-3 h5 text-center bg-light">
          {{task?.task_group?.task_group_name || task?.timesheet_task_group_fk_task_group_name}}
        </div>
        <ng-container *ngFor="let task of task?.task_group_child">
          <div class="kt-widget2__item " [class.kt-widget2__item--danger]="!task.selected"
            [class.kt-widget2__item--success]="task.selected">
            <div class="kt-widget2__checkbox w-100">
              <label class="kt-checkbox kt-checkbox--brand">
                <!-- checkbox configuration  start -->
                <input type="checkbox" [(ngModel)]="task.selected" [disabled]="viewMode || currentStatus === shiftStatusEnum.OnBreak || currentStatus === shiftStatusEnum.None"
                  (change)="taskSelectChangeHandler(task.selected, task)">
                <!-- checkbox configuration  end -->
                <b>{{task.task_group_child_task}}</b><br>
                {{task?.task_group_child_note}}
                <span></span>
              </label>
              <span class="float-end" *ngIf="task.task_group_child_multiple">
                <b> <i> Done
                    {{task?.actual_task_group_child ?
                    task.actual_task_group_child.timesheet_task_group_child_multiple_count : 0}}
                    Times</i> </b>
              </span>
              <span *ngIf="task.custom" class="kt-font-brand">(custom)</span>
            </div>
            <!-- <div class="text-end" style="width: 100px;" *ngIf="viewMode">
              Count : {{task?.timesheet_task_group_child_multiple_count}}
            </div> -->

          </div>
        </ng-container>
        <div class="text-end mt-2" *ngIf="extraTaskFormGroup?.controls?.length === 0 || !saveData">
          <button class="btn btn-brand btn-sm" [style.cursor]="currentStatus === shiftStatusEnum.OnBreak || currentStatus === shiftStatusEnum.None ? 'default' : 'pointer'" (click)="addClickHandler()" [hidden]="viewMode || currentStatus === shiftStatusEnum.OnBreak || currentStatus === shiftStatusEnum.None"> Add Custom
            Sub-Task</button>
        </div>
        <span class="text-danger" *ngIf="currentStatus === shiftStatusEnum.OnBreak || currentStatus === shiftStatusEnum.None">The tasks are in READ-ONLY mode. Please start shift to perform the tasks.</span>
        <ng-container *ngFor="let extraTask of extraTaskFormGroup.controls;let i = index">
          <div class="row">
            <div class="col-8 form-group">
              <kt-textbox *ngIf="!extraTask.value.saved" [field]="taskGroupListActionControls.task_group"
                [form]="extraTask"></kt-textbox>
              <div *ngIf="extraTask.value.saved" class="kt-widget2__item kt-widget2__item--success">
                <div class="kt-widget2__checkbox">
                  <label class="kt-checkbox kt-checkbox--brand">
                    <!-- checkbox configuration  start -->
                    <input type="checkbox" checked [disabled]="true">
                    <!-- checkbox configuration  end -->
                    {{extraTask?.value.task_group}}

                    <span></span>
                  </label>

                </div>
              </div>
            </div>
            <div class="col-2 d-flex align-items-center mt-2">

              <kt-button *ngIf="saveData" [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG"
                (buttonClick)="saveButtonClickHandler(true, null)">
              </kt-button>

              <kt-button *ngIf="!saveData && !extraTask.value.saved" [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG"
                (buttonClick)="internalSaveClick(extraTask); ">
              </kt-button>
            </div>
            <div class="col-2 d-flex align-items-center">
              <button (click)="removeTaskGroup(i)" class="btn btn-sm btn-clean btn-icon btn-icon-md">
                <svg-icon class="svg_icon13x13 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/delete.svg"></svg-icon>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </kt-loader>


    <!-- Footer -->
    <div class="modal-footer d-flex justify-content-between ">
      <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
      </kt-button>
      <kt-button *ngIf="!saveData" [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG"
        (buttonClick)="saveButtonClickHandler(true, null)">
      </kt-button>
    </div>

  </div>
</kt-base-modal>
